// «Después en la venta»: lo que la promo de venta elegida entrega al cerrar (slot `afterSale`).
import { formatMXN } from '@/shared/lib/format/money';
import { accountBonusText } from '@/domains/sales/wizard/accountBonuses';
import { useSalePromotionEvaluation } from '../api/useWizardPromotions';
import type { AfterSaleBenefit } from '../api/wizardPromotionsContract';
import { chosenPromotionIds } from '../lib/promotionSelection';
import { useSessionPromotionState } from '../store/promotionSelectionStore';

export function afterSaleText(benefit: AfterSaleBenefit): string {
    const amount = benefit.amountCents === null ? '' : formatMXN(benefit.amountCents / 100);
    const quantity = String(benefit.quantity ?? 0);
    switch (benefit.lever) {
        case 'WALLET_BONUS':
            return accountBonusText(benefit.amountCents);
        case 'EXTENDED_WARRANTY':
            return `${quantity} meses más de garantía`;
        case 'AIRTIME':
            return `${quantity} recargas de tiempo aire de ${amount}`;
        case 'COUPON':
            return amount
                ? `Cupón de ${amount} para tu próxima compra`
                : 'Cupón para tu próxima compra';
        default:
            return '';
    }
}

export function AfterSaleBenefits({ sessionId }: { sessionId: string }) {
    const { data } = useSalePromotionEvaluation(sessionId);
    const { selection } = useSessionPromotionState(sessionId);
    const chosenIds = new Set(chosenPromotionIds(selection));
    const items = (data?.promotions ?? [])
        .filter((p) => p.kind === 'SALE' && chosenIds.has(p.promotionId))
        .flatMap((p) => p.afterSale.map(afterSaleText))
        .filter(Boolean);
    if (items.length === 0) return null;
    return (
        <section
            aria-label="Después en la venta"
            className="flex flex-col gap-1 border-t border-border pt-2.5"
        >
            <div className="text-[11px] font-semibold uppercase tracking-[0.06em] text-warning">
                Después en la venta
            </div>
            <ul className="flex flex-col gap-0.5 text-[13px]">
                {items.map((text) => (
                    <li key={text}>{text}</li>
                ))}
            </ul>
        </section>
    );
}
